module.exports = __webpack_public_path__ + "img/complacency.ea0e68e1.jpg";